<template>
  <div id="showDetail">
    <div class="showDetail" :style="{ display: display, top: top, left: left }">
      <span>{{ text }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShowDetail",
  props: {
    text: String,
    display: {
      type: String,
      default: "none",
    },
    top: {
      type: String,
      default: "0.4rem",
    },
    left: {
      type: String,
      default: "1.8rem",
    },
  },
};
</script>

<style scoped lang="less">
.showDetail {
  position: absolute;
  // top: 0.4rem;
  // left: 1.8rem;
  color: @main-col;
  font-family: "PSYCHO";
}
</style>